import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { publicRoutes, profileRoutes } from 'routes';
import { useEffect } from 'react';

import { useAuthModal } from 'context/AuthModalContext';
import { listenAuthModalEvent } from 'context/AuthModalEvent';
import ModalAuth from 'components/ModalAuth';
import ProfileLayout from 'pages/Profile/ProfileLayout';
import 'animate.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-day-picker/dist/style.css';
import 'react-loading-skeleton/dist/skeleton.css';
// import 'react-multi-carousel/lib/styles.css';
// import 'react-range-slider-input/dist/style.css';
// import 'react-day-picker/dist/style.css';

function App() {
  const { openModal } = useAuthModal();

  useEffect(() => {
    const unsubscribe = listenAuthModalEvent(({ type }) => {
      openModal(type);
    });
    return unsubscribe;
  }, [openModal]);

  return (
    <div className="font-sans h-full">
      <Router>
        <Routes>
          {publicRoutes.map((item, key) => (
            <Route key={key} element={item.element} path={item.path} />
          ))}
          <Route element={<ProfileLayout />}>
            {profileRoutes.map((item, key) => (
              <Route key={key} element={item.element} path={item.path} exact={item.exact} />
            ))}
          </Route>
        </Routes>
        <GlobalAuthModal />
      </Router>
    </div>
  );
}

function GlobalAuthModal() {
  const { open, closeModal } = useAuthModal();
  return <ModalAuth open={open} setOpen={closeModal} />;
}

export default App;
